module.exports = __webpack_public_path__ + "static/media/web_services.a37a4156.jpg";